import {
  getStickyHeaderHeight,
  getMainSubheaderHeight,
  getSecondarySubheaderHeight,
  getSystemBannerHeight,
} from '@app/utils/domHelpers'

export const getTableTopOffset = (
  table: HTMLElement,
  scrollableElement: Element | Window
): number =>
  table.getBoundingClientRect().top +
  getScrollingPosition(scrollableElement) -
  getHeaderOffset()

export const getTableBottomOffset = (
  table: HTMLElement,
  scrollableElement: Element | Window
): number =>
  table.getBoundingClientRect().bottom +
  getScrollingPosition(scrollableElement) -
  getHeaderOffset()

export const getHeaderOffset = (): number => {
  return [
    getStickyHeaderHeight(),
    getMainSubheaderHeight(),
    document.getElementById('secondary-subheader')
      ? getSecondarySubheaderHeight()
      : '0px',
    getSystemBannerHeight(),
  ].reduce((acc, height) => {
    return acc + parseInt(height.replace('px', ''), 10)
  }, 0)
}

export const getScrollingPosition = (
  scrollableElement: Element | Window
): number =>
  scrollableElement instanceof Window
    ? scrollableElement.scrollY
    : scrollableElement.scrollTop
